/* eslint-disable react/prop-types */
import React from "react";
import { Divider, Layout, Typography, Table, Tag, Space, Row } from "antd";
import functions from "../../components/utils/functions";

const { Content } = Layout;
const { Title } = Typography;

const STATUS_TAGS = {
  pending: { color: "warning", text: "Pending" },
  success: { color: "success", text: "Success" },
  initiated: { color: "processing", text: "Initiated" },
  failed: { color: "error", text: "Failed" },
};

const netPayoutAmount = (totalRevenue) =>
  `₹${functions.formatIndianNumber(0.65 * (Number(totalRevenue) || 0), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const columns = [
  {
    title: "Project",
    dataIndex: "project_title",
    key: "project_title",
    width: 160,
  },
  {
    title: "Platform",
    dataIndex: "platform_name",
    key: "platform_name",
    width: 140,
    render: (name, row) => name || row.platform_id,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 110,
    render: (status) => {
      const info = STATUS_TAGS[status] || STATUS_TAGS.pending;
      return <Tag color={info.color}>{info.text}</Tag>;
    },
  },
  {
    title: "Period",
    dataIndex: "period_label",
    key: "period_label",
    width: 200,
  },
  {
    title: "Net Payout",
    key: "total_revenue",
    width: 120,
    render: (_, r) => netPayoutAmount(r.total_revenue),
  },
];

const DemoPayoutsTable = ({ rows }) => (
  <Content className="vc-panel" style={{ padding: 24, margin: 0 }}>
    <Title level={4}>Payouts</Title>
    <Divider />
    <Table
      dataSource={rows}
      columns={columns}
      rowKey={(r) => `${r.project_id}-${r.platform_id}-${r.status}`}
      pagination={false}
      scroll={{ x: 900 }}
    />
    <Space direction="vertical" style={{ textAlign: "left", marginTop: 16 }}>
      <Row>
        <Tag color="warning">Pending</Tag> — Payment not yet received from the
        platform.
      </Row>
      <Row>
        <Tag color="processing">Initiated</Tag> — Payment received from the
        platform and transfer initiated.
      </Row>
      <Row>
        <Tag color="success">Success</Tag> — Payment transferred to your
        account.
      </Row>
      <Row>
        <Tag color="error">Failed</Tag> — Transfer failed. Contact support.
      </Row>
    </Space>
  </Content>
);

export default DemoPayoutsTable;
